/** @format */

import { createFileRoute, redirect } from "@tanstack/react-router";
import { Suspense } from "react";

import { lazyWithRetry } from "@/utils/lazyWithRetry";
import PageLoader from "@/utils/PageLoader";
import { RouteErrorComponent } from "@/utils/RouteErrorComponent";

const ResetPasswordPage = lazyWithRetry(
  () => import("@/pages/Auth/ResetPasswordConfirm")
);

export const Route = createFileRoute("/reset-password/$uid/$token")({
  beforeLoad: ({ params }) => {
    if (!params.uid || !params.token) {
      // eslint-disable-next-line @typescript-eslint/only-throw-error
      throw redirect({ to: "/" });
    }
  },
  component: () => (
    <Suspense fallback={<PageLoader />}>
      <ResetPasswordPage />
    </Suspense>
  ),
  errorComponent: RouteErrorComponent,
});
